export const waaroverGaatUwVraagPropWmo = "stap_contactvraag__contactvraag.waaroverGaatUwVraagWmo";
export const waaroverGaatUwVraagPropWlz = "stap_contactvraag__contactvraag.waaroverGaatUwVraagWlz";
export const regelingProp = "stap_contactvraag__contactvraag.regeling";
export const voorWieSteltUDeVraagProp = "stap_contactvraag__contactvraag.voorWieSteltUEenVraag";
export const neeProp = "nee";
export const jaProp = "ja";
export const contactgegevensSectionName = "stap_contactgegevens__contactgegevens";
export const voorKlantSectionName = "stap_contactgegevens__voorKlant";
